import * as React from "react";
import { useNavigate } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { Button, Dialog } from "@chotca/ui";
import { useMe } from "@chotca/api-client";

// Blocks a screen behind an "account must reach U1_CONTACT" popup (SCRUM-74).
// Used on surfaces that expose an applicant's real phone number — the employer
// must verify their own email + phone first. U1/U2 pass through; U0 is blocked.
// The actual verification (email / phone / CCCD) all lives on /profile, so this
// gate just routes the user there rather than duplicating the verify flows.
export function IdentityRequiredGate({
  children,
}: {
  children: React.ReactNode;
}) {
  const nav = useNavigate();
  const me = useMe();

  // While loading, render nothing rather than flashing the gate.
  if (!me.data) return <>{children}</>;

  const level = me.data.identityLevel ?? "U0_NEW";
  if (level !== "U0_NEW") return <>{children}</>;

  return (
    <Dialog
      open
      onClose={() => nav("/dashboard")}
      title="Xác minh tài khoản để xem ứng viên"
      description="Để xem thông tin liên hệ của ứng viên, bạn cần xác minh email và số điện thoại của mình. Ứng viên cũng chỉ liên hệ với nhà tuyển dụng đã xác minh."
      footer={
        <div className="flex justify-end gap-2">
          <Button variant="ghost" onClick={() => nav("/dashboard")}>
            Để sau
          </Button>
          <Button onClick={() => nav("/profile")}>Xác minh tài khoản</Button>
        </div>
      }
    >
      <div className="flex items-start gap-3 rounded-xl bg-mist p-3">
        <ShieldAlert size={20} className="mt-0.5 shrink-0 text-ash" />
        <p className="text-sm text-ink/80">
          Vào trang hồ sơ để xác minh email và số điện thoại của bạn.
        </p>
      </div>
    </Dialog>
  );
}
